import { render } from "./DetalleVenta.vue?vue&type=template&id=20936bc6&scoped=true"
import script from "./DetalleVenta.vue?vue&type=script&lang=js"
export * from "./DetalleVenta.vue?vue&type=script&lang=js"

import "./DetalleVenta.vue?vue&type=style&index=0&id=20936bc6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20936bc6"]])

export default __exports__